import script from "./ChooseScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseScreen.vue?vue&type=script&setup=true&lang=js"

import "./ChooseScreen.vue?vue&type=style&index=0&id=13a835fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13a835fb"]])

export default __exports__